import qs, { type StringifyOptions } from 'query-string';

interface QueryOptions {
  url: string;
  queryParams: Record<string, any>;
}

// TODO 서버에서 generateQueryKeyUrl 사용하는 로직 제거 필요
export const generateQueryKeyUrl = (
  { url, queryParams }: QueryOptions,
  stringifyOptions?: StringifyOptions,
) => ({
  url: qs.stringifyUrl(
    { url, query: queryParams },
    { skipEmptyString: true, skipNull: true, ...stringifyOptions },
  ),
  queryKey: [url, queryParams],
});
